import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { registerAxiosSessionInterceptor } from './utils/sessionAuth';
import App from './App';

registerAxiosSessionInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
